import React, {Fragment} from 'react';
import createEditor from '../form/ComponentEditor';
import Box from '../layout/Box';
import VideoForm from './forms/videoForm';
import VideoList from './lists/videoList';
import BoxEditor from "./BoxEditor";
import Button from "../form/Button";

class videoEditor extends React.Component {

    loadForm = async (data) => {
        await this.props.loadForm(data);
        this.editor && this.editor.focus();
    }

    pristineForm = async () => {
        await this.props.pristineForm();
        this.editor && this.editor.focus();
    }

    saveForm = async (event) => {
        await this.props.saveForm(event);
        this.list && this.list.refresh();
    }

    render() {
        const List = this.props.list || Box;
        const Editor = this.props.editor || BoxEditor;
        return (
            <Fragment>
                <List
                    {...this.props}
                    theme="default"
                    header={"Videók"}
                    footer={[
                        <Button key="0" color="default" disabled={this.props.isLoading} onClick={ this.pristineForm }>
                            Új
                        </Button>
                    ]}
                >
                    <VideoList ref={(el) => this.list = el} {...this.props} loadForm={this.loadForm} />
                </List>
                <Editor
                    {...this.props}
                    ref={(editor) => this.editor = editor}
                    theme="default"
                    header={"Videó"}
                    footer={[
                        <Button key="0" disabled={ !this.props.dirty || this.props.isLoading } color="primary" className="pull-right" onClick={ this.saveForm }>
                            Mentés
                        </Button>
                    ]}
                >
                    <VideoForm {...this.props} />
                </Editor>
            </Fragment>
        );
    }
}

export default createEditor({componentName: "video", WrappedComponent: videoEditor, props: {view: "admin"}});
